import {NavLink, useParams} from "react-router-dom"
// import catData from "./categories_sample"
import "./_style.css"
import FieldsFilterBlock from "./FieldsFilterBlock"
import PaginationBar from "../../components/PaginationBar"
import {useState, useEffect, useContext} from "react"
import {ICatGridFilter, ICatGridQuery} from '../../helpers/Interfaces'
import AuthContext from "../../context/AuthContext";
import BreadCrumbs from "../../components/BreadCrumbs";
import Footer from "../../components/Footer";
import {LightTooltip} from "../_subcomponents/MapToolsBase";
import AddCardIcon from "@mui/icons-material/AddCard";
import * as React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PausePresentationIcon from "@mui/icons-material/PausePresentation";
import DialogParkSrcField from "../_subcomponents/DialogParkSrcField";


// Header of Target Fields grid table
function FieldsGridHeader(props:any) {
    const {taxType, fieldType} = props
    let capFieldType = fieldType ? fieldType.charAt(0).toUpperCase() + fieldType.slice(1) : 'Field'

    return (
        <div className="grid-base grid-header fields-grid-columns">
            <div>#</div>
            <div>Taxonomy</div>
            <div>Field Type</div>
            <div>{capFieldType} ID</div>
            <div>{capFieldType} Name</div>
            <div>
                {fieldType == 'category' ? <>Feats #</> : <>&nbsp;</>}
            </div>
            <div>Status</div>
            {/*<div>Comment</div>*/}
            <div>{taxType == 'target' ? <>Updated on</> : <>Actions</>}</div>
        </div>
    )
}


// One Row (a piece) of the Fields List Table
function FieldGridRow(props: any) {

    const {num, fieldObj, taxType, taxName, userPermissions, setParkFieldDial} = props    // catObj = {'id': 6728, 'cat_id': '80009196', 'cat_name': '2-taktbenzine', 'num_feats': 21}
    // console.log(fieldObj)

    // let capitalFieldType = fieldType.charAt(0).toUpperCase() + fieldType.slice(1);

    const userCanEdit: boolean = Boolean(userPermissions?.canEdit)

    function handleSrcParkClick() {
        if ( userCanEdit || !userCanEdit && fieldObj.mapStatus == 'parked' ) {
            setParkFieldDial((prev: any) => {
                return {...prev, isOpen: true, srcFieldObj: fieldObj}
            })
        } else {
            // no action needed
        }
    }

    // MAIN IF-ELSE PART
    if (taxType === 'target') {
        let mapLink = `../map/${fieldObj.fieldUID}`

        let mapComment = 'N', mapDate = ''
        try {
            mapComment = !fieldObj.mapData.mapRemark ? 'N' : 'Y'
            mapDate = fieldObj.mapData.mapDate
        } catch (e) {}

        let trgMapStatus = 'not mapped'
        try {
            trgMapStatus = fieldObj.mapData.mapStatus ? 'mapped' : 'not mapped'
        } catch (e) {
        }

        return (
            <div className="grid-base grid-row fields-grid-columns">
                <div>{num}</div>
                <div>{taxName}</div>
                <div>{fieldObj.fieldType}</div>
                <div className="cell-value-id">{fieldObj.fieldID}</div>

                <div className="grid-row-itemlink">
                    <NavLink to={mapLink}>{fieldObj.fieldName}</NavLink>
                </div>

                <div>
                    {fieldObj.fieldType == 'category' ? <>{fieldObj.featsNum}</> : <>&nbsp;</>}
                </div>

                <div>{trgMapStatus}</div>
                {/*<div>{mapComment}</div>*/}

                <div>{mapDate}</div>
            </div>
        )


    } else {      // taxType === 'source'
        let usageLink = `../${fieldObj.fieldUID}/srcusage`

        let mapLink = `../map/${fieldObj.fieldUID}/usemap`

        const usageIconStyles: any = {
            'parked': {color: 'grey', cursor: 'auto'},
            'not mapped': {color: 'grey', cursor: 'pointer'},
            'mapped': {color: '#2f478e', cursor: 'pointer'}
        }
        const styleUsageIcon: any = usageIconStyles[fieldObj.mapStatus] || {}

        let srcParkIconStyle = {}
        if (fieldObj.mapStatus == 'parked') {
            srcParkIconStyle = {
                color: '#cc0000',
                cursor: "pointer"
            }
        } else if (!userCanEdit) {
            srcParkIconStyle = {
                color: 'grey',
                cursor: "auto"
            }
        } else {
            srcParkIconStyle = {
                color: '#2f478e',
                cursor: "pointer"
            }
        }

        return (
            <div className="grid-base grid-row fields-grid-columns">
                <div>{num}</div>
                <div>{taxName}</div>
                <div>{fieldObj.fieldType}</div>
                <div className="cell-value-id">{fieldObj.fieldID}</div>

                <div className="cell-value-name">{fieldObj.fieldName}</div>

                <div>
                    {fieldObj.fieldType == 'category' ? <>{fieldObj.featsNum}</> : <>&nbsp;</>}
                </div>
                <div>{fieldObj.mapStatus}</div>

                <div className="actions-col">
                    <NavLink to={fieldObj.mapStatus == 'parked' ? '' : usageLink}
                             style={{margin: 'auto 15px auto 5px'}}>
                        <LightTooltip
                            title={fieldObj.mapStatus == 'parked' ? 'Action not possible. The field is parked.' : "List of mappings where this field is used in"}>
                            <FormatListBulletedIcon fontSize="small" style={styleUsageIcon}/>
                        </LightTooltip>
                    </NavLink>

                    <NavLink to={fieldObj.mapStatus == 'parked' ? '' : mapLink}>
                        <LightTooltip
                            title={fieldObj.mapStatus == 'parked' ? 'Action not possible. The field is parked.' : "Use for mapping. Source field can be used for mappings multiple times."}>
                            <AddCardIcon fontSize="small" style={fieldObj.mapStatus == 'parked' ? {color: 'grey', cursor: 'auto'} : {color: '#2f478e'} }/>
                        </LightTooltip>
                    </NavLink>

                    <LightTooltip
                        title={fieldObj.mapStatus == 'parked' ? "The feature is parked. Click to unpark and make it available for mappings" : "Park source field"}>
                        {/*<LightTooltip title="">*/}
                        <PausePresentationIcon
                            fontSize="small"
                            style={srcParkIconStyle}
                            onClick={handleSrcParkClick}
                            // onClick={
                            //     userPermissions.canEdit ? () => setParkFieldDial((prev: any) => {
                            //             return {...prev, isOpen: true, srcFieldObj: fieldObj}
                            //         }
                            //     ) : undefined
                            // }
                        />
                    </LightTooltip>

                </div>
            </div>
        )
    }
}


// Full Table Formed
export default function FieldsList() {

    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    // console.log(userPermissions)

    // Fetching Categories List
    const {prjid, page_num} = useParams()

    // when user clicks "Back" in browser than filters are preserved
    let preFilter = localStorage.getItem("filterFields")
    let storFilter: ICatGridFilter | any = null
    if (preFilter) {
        storFilter = JSON.parse(preFilter)
    }


    const [filterObj, setFilterObj] = useState<ICatGridFilter>({
        taxType: 'source',
        fieldType: '',
        fieldID: '',
        fieldName: '',
        mapStatus: '',
        mapRemark: ''
    })
    // console.log('->', filterObj)

    const [pageData, setPageData] = useState({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: [],
        taxName: '',
        currentPage: null
    })

    const [queryObj, setQueryObj] = useState<ICatGridQuery>({
        postsPerPage: 20,
        projID: prjid,
        // currentPage: +(page_num || 1),
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: storFilter ? storFilter : filterObj
    })
    // console.log('Query obj:', queryObj)

    useEffect(() => {

        // re-sets filterObj for when user came from "Back" button in browser
        if (storFilter) {
            setFilterObj(storFilter)
        }

        getFieldsData()

    }, [queryObj])


    let getFieldsData = async () => {
        let response = await fetch(`${serverIP}/getfieldslist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(queryObj),
        })
        let data = await response.json()

        if (response.status === 200) {
            setPageData(prevState => {
                return {
                    ...prevState,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    dataList: data.pagePosts,
                    currentPage: data.currentPage,
                    taxName: data.taxName
                }
            })
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const paginate = (pageNumber: number) => setQueryObj(prevState => {
        return {...prevState, currentPage: pageNumber}
    });

    const [parkFieldDial, setParkFieldDial] = useState<any>({
        isOpen: false,
        srcFieldObj: {}
    });

    const rowElements = pageData.dataList.map((item, index) => {
        return <FieldGridRow
            key={index + pageData.firstPostIndx}
            num={index + 1 + pageData.firstPostIndx}
            fieldObj={item}
            taxType={queryObj.filterObj.taxType}
            // fieldType={queryObj.filterObj.fieldType}
            taxName={pageData.taxName}
            userPermissions={userPermissions}
            setParkFieldDial={setParkFieldDial}
        />
    })

    // useEffect(() => {
    //     window.scrollTo(0, 500)
    // }, [currentPage]);

    // useEffect(() => {
    //     console.log('Effected on tax_type change')
    // }, [filterObj.tax_type]);

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Fields List', 'link': ''}
    ]

    return (

        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <FieldsFilterBlock
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                queryObj={queryObj}
                setQueryObj={setQueryObj}
            />

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small><i>Listing {pageData.totalPosts} items</i></small></div>

                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../`}
                />
            </div>

            {/*{queryObj.filterObj.taxType === 'target' ? <TrgFieldsGridHeader/> : <SrcFieldsGridHeader/>}*/}
            <FieldsGridHeader taxType={queryObj.filterObj.taxType} fieldType={queryObj.filterObj.fieldType} />

            <div className="grid-rows-container"> {/*  style={{minHeight: "400px"}}  */}
                {rowElements}
            </div>

            <DialogParkSrcField
                parkObj={parkFieldDial}
                setParkObj={setParkFieldDial}
                projUID={prjid}
                refreshFunc={getFieldsData}
            />

            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../`}
            />

            <Footer/>

        </>
    )
}
